import { RESET_ASSIGN_PRODUCT_FORM } from '../actionTypes';
import { installersActions } from '../reducer';

export default () => installersActions[RESET_ASSIGN_PRODUCT_FORM]();
